import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { scrollToTop } from 'common';

type HandleSourcingSharedOnReviewInvitationsBackControllerProps = {
  set: SharedSourcingStoreApi['setState'];
};

export const handleSourcingSharedOnReviewInvitationsBackController = ({
  set
}: HandleSourcingSharedOnReviewInvitationsBackControllerProps) => {
  scrollToTop();
  set({
    step: 'CUSTOMIZE_MESSAGE'
  });
};
